var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-data"},[_c('DataCard',{attrs:{"title":"Stake Statistics","data":_vm.stakeStatsArray,"min-width":"500"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }